import { LANGUAGES } from '../i18n/languages'
import type { Language } from '../types/document'

/** Compact dropdown, used where space is tight (result screen, photo check). */
export function LanguagePicker({
  label,
  value,
  onChange,
  compact = false,
  id
}: {
  label: string
  value: Language
  onChange: (language: Language) => void
  compact?: boolean
  id: string
}) {
  return (
    <div className={`language-picker ${compact ? 'compact' : ''}`}>
      {label && <label htmlFor={id}>{label}</label>}
      <select id={id} value={value} onChange={(event) => onChange(event.target.value as Language)} aria-label={label || 'Language'}>
        {LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code} lang={lang.bcp47}>
            {lang.nativeName}
            {lang.nativeName !== lang.englishName ? ` · ${lang.englishName}` : ''}
          </option>
        ))}
      </select>
    </div>
  )
}

/** All twelve languages laid out as big buttons, so no one has to hunt for theirs. */
export function LanguageGrid({
  label,
  value,
  onChange
}: {
  label: string
  value: Language
  onChange: (language: Language) => void
}) {
  return (
    <fieldset className="language-grid">
      <legend>{label}</legend>
      <div className="language-grid-items">
        {LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            type="button"
            lang={lang.bcp47}
            className={lang.code === value ? 'selected' : ''}
            aria-pressed={lang.code === value}
            onClick={() => onChange(lang.code)}
          >
            <span className="native">{lang.nativeName}</span>
            {lang.nativeName !== lang.englishName && <span className="english">{lang.englishName}</span>}
          </button>
        ))}
      </div>
    </fieldset>
  )
}
